module.exports = __webpack_public_path__ + "img/logo.0b450c4c.jpg";